var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 8.49866,
    x2: 8.40909,
    y2: 8.49866,
    stroke: "#E01A4F"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1136,
    y1: 8.49866,
    x2: 13.5227,
    y2: 8.49866,
    stroke: "#E01A4F"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.2273,
    y1: 8.49866,
    x2: 18.6364,
    y2: 8.49866,
    stroke: "#E01A4F"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 11.3277,
    x2: 8.40909,
    y2: 11.3277,
    stroke: "#E01A4F"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1136,
    y1: 11.3277,
    x2: 13.5227,
    y2: 11.3277,
    stroke: "#E01A4F"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 15.2273,
    y1: 11.3277,
    x2: 18.6364,
    y2: 11.3277,
    stroke: "#E01A4F"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 14.1567,
    x2: 8.40909,
    y2: 14.1567,
    stroke: "#E01A4F"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1136,
    y1: 14.1567,
    x2: 13.5227,
    y2: 14.1567,
    stroke: "#E01A4F"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 16.9857,
    x2: 8.40909,
    y2: 16.9857,
    stroke: "#E01A4F"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1136,
    y1: 16.9857,
    x2: 13.5227,
    y2: 16.9857,
    stroke: "#E01A4F"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 15.2273,
    y1: 16.9857,
    x2: 18.6364,
    y2: 16.9857,
    stroke: "#E01A4F"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 15.2273,
    y1: 14.1567,
    x2: 18.6364,
    y2: 14.1567,
    stroke: "#E01A4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 2V6.24351M6.63636 4.04317H4.25C3.55964 4.04317 3 4.66239 3 5.42624V19.2569C3 20.0208 3.55964 20.64 4.25 20.64H19.25C19.9404 20.64 20.5 20.0208 20.5 19.2569V5.42624C20.5 4.66239 19.9404 4.04317 19.25 4.04317H6.63636ZM6.63636 4.04317V6.24351V2",
    stroke: "#E01A4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.91cc088512f3ff98335b0903ffca39a5.svg";
export { ForwardRef as ReactComponent };